"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuestionnaireNavigation = void 0;
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _uiActions = require("../../store/ui/uiActions");
var _reactRedux = require("react-redux");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _constants = require("../../utils/constants");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _questionnaireMetadataHelper = require("./helpers/questionnaireMetadataHelper");
var _questionSummaryHelper = require("./helpers/questionSummaryHelper");
var getAreSelectionsValid = function getAreSelectionsValid(question, selections) {
  if (question.type === _constants.QUESTION_TYPE.MULTI) {
    // selections should be equal or more than multi item - every item is a different component.
    return selections.filter(function (sel) {
      return sel !== undefined;
    }).length >= question.multi.length;
  }
  if (question.type === _constants.QUESTION_TYPE.ADDRESS_SEARCH) {
    return selections[0] && Object.values(selections[0]).filter(Boolean).length > 1;
  }
  return selections.length > 0;
};
var getNextQuestionIndex = function getNextQuestionIndex(questions, currentQuestionIndex, flags) {
  var nextQuestionIndex = currentQuestionIndex + 1;
  while (nextQuestionIndex < questions.length) {
    var question = questions[nextQuestionIndex];
    var checkFlag = question.if && flags[question.if] && !question.unless || question.unless && !flags[question.unless] && !question.if || question.unless && question.if && flags[question.if] && !flags[question.unless] || !question.unless && !question.if;
    if (checkFlag) {
      return nextQuestionIndex;
    }
    console.log("Skipping ".concat(nextQuestionIndex));
    nextQuestionIndex++;
  }
  return _constants.RECOMMENDATION_PAGE_INDEX;
};
var useQuestionnaireNavigation = function useQuestionnaireNavigation() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var progressPercentage = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectQuestionnaireProgress);
  var questions = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectQuestions);
  var currentQuestion = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentQuestion);
  var currentQuestionIndex = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentQuestionIndex);
  var currentSelections = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentSelections);
  var hasValidSelections = getAreSelectionsValid(currentQuestion, currentSelections);
  var answers = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectQuestionnaireAnswers);
  var isFirstQuestion = currentQuestionIndex === 0;
  var isBudgetAdjusted = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectIsBudgetAdjusted);
  var skipMetadata = (0, _questionnaireUtil.isBudgetQuestion)(currentQuestion) && !isBudgetAdjusted;
  var onRestart = function onRestart() {
    dispatch((0, _questionnaireActions.resetQuestionnaire)());
  };
  var onBack = function onBack() {
    dispatch((0, _questionnaireActions.gotoPreviousQuestion)());
  };
  var onNext = function onNext() {
    var metadata = (0, _questionnaireMetadataHelper.getQuestionnaireMetadata)(currentQuestion, currentSelections, answers, skipMetadata);
    var nextQuestionIndex = getNextQuestionIndex(questions, currentQuestionIndex, metadata.flags);
    var id = "q-".concat(currentQuestionIndex);
    var summary = (0, _questionSummaryHelper.getQuestionSummary)(currentQuestion, currentSelections);
    var time = new Date(Date.now());
    var description = currentQuestion.title;
    dispatch((0, _uiActions.updateTimestamp)({
      id: id,
      time: time,
      description: description
    }));
    dispatch((0, _questionnaireActions.gotoNextQuestion)({
      nextQuestionIndex: nextQuestionIndex,
      metadata: metadata,
      summary: summary
    }));
    if (nextQuestionIndex === _constants.RECOMMENDATION_PAGE_INDEX) {
      dispatch((0, _questionnaireActions.endQuestionnaire)());
    }
  };
  var onSkip = function onSkip() {
    var metadata = (0, _questionnaireMetadataHelper.getQuestionnaireMetadata)(currentQuestion, currentSelections, answers, skipMetadata);
    var nextQuestionIndex = getNextQuestionIndex(questions, currentQuestionIndex, metadata.flags);
    dispatch((0, _questionnaireActions.skipQuestion)(nextQuestionIndex));
    if (nextQuestionIndex === _constants.RECOMMENDATION_PAGE_INDEX) {
      dispatch((0, _questionnaireActions.endQuestionnaire)());
    }
  };
  return {
    onRestart: onRestart,
    onBack: onBack,
    onNext: onNext,
    onSkip: onSkip,
    isRestartVisible: !isFirstQuestion,
    isBackVisible: !isFirstQuestion,
    isNextEnabled: hasValidSelections,
    progressPercentage: progressPercentage
  };
};
exports.useQuestionnaireNavigation = useQuestionnaireNavigation;